module.exports = __webpack_public_path__ + "media/images/front/icon_04_arrow_gr-bd02a0053bb20856d1e70ae5adbba926.png";